import { NgModule } from '@angular/core';
import { OccConfig, provideConfig, provideDefaultConfigFactory, provideFeatureToggles } from '@spartacus/core';
import {
    defaultCmsContentProviders,
    layoutConfig,
    mediaConfig,
} from '@spartacus/storefront';
import { environment } from '../../environments/environment';
import { defaultAuthConfigFactory } from './config/auth.config';

// only provide the `occ.baseUrl` key if it is explicitly configured, otherwise the value of
// <meta name="occ-backend-base-url" > is ignored.
// This in turn breaks the deployment in CCv2.
// https://github.com/SAP/spartacus/issues/5886
const occConfig: OccConfig = {
  backend: {
    occ: {
      prefix: '/occ/v2/',
      useWithCredentials: true,
    },
  },
};
if (environment.occBaseUrl) {
  occConfig.backend.occ.baseUrl = environment.occBaseUrl;
}

const PRODUCT_TYPE = 'DEFAULT';

@NgModule({
  declarations: [],
  providers: [
    provideDefaultConfigFactory(defaultAuthConfigFactory),
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig({
      backend: occConfig.backend,
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        // TODO: adjust origins as necessary
        allowOrigin:
          'localhost:9002, *.*.model-t.cc.commerce.ondemand.com:443, *.pharma.aventis.com:443, *.*.sanofiecomm.com:443',
      },
      context: {
        urlParameters: ['baseSite', 'language', 'currency'],
        baseSite: ['dz'],
        currency: ['DZD'],
        language: ['fr_DZ', 'en'],
      },
      features: {
        level: '6.0',
      },
    }),
    provideConfig({
      backend: {
        occ: {
          endpoints: {
            asmCustomerSearch: '/occ/v2/dz/assisted-service/customers/search',
          },
        },
      },
    } as OccConfig),
    provideFeatureToggles({
      a11yKeyboardAccessibleZoom: false,
      a11yPreventCartItemsFormRedundantRecreation: false,
      a11yLinkBtnsToTertiaryBtns: false,
      a11yNgSelectAriaControls: false,
      enableReadDomainValuesOnDemand: false,
      unifiedDefaultHeaderSlotsAcrossBreakpoints: false,
      cdsLoginEventsToken: true,
      dispatchLoginActionOnlyWhenTokenReceived: true,
      incrementProcessesCountForMergeCart: true,
      authorizationCodeFlowByDefault: true,
    })
  ],
})
export class SpartacusConfigurationModule {}
